import { StateRepository } from '@angular-ru/ngxs/decorators'
import { State } from '@ngxs/store'
import { Injectable } from '@angular/core'
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories'

export interface SimpleFilterExternalStateModel {
  [key: string]: string[]
}

@StateRepository()
@State({
  name: 'simpleFilterExternalState',
  defaults: {},
})
@Injectable()
export class SimpleFilterExternalState extends NgxsDataRepository<SimpleFilterExternalStateModel> {}
